// extracted by mini-css-extract-plugin
export default {"layout":"layout___qvVeD","captionContainer":"captionContainer___pN_yQ","caption":"caption___wYAe2","source":"source___Rr9Dl"};